exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".gA4cC0vw1fFCPR_7UtEb4{float:left;line-height:1.8;padding-right:1rem;width:100%}.gA4cC0vw1fFCPR_7UtEb4:after{background:#ccc;content:\"\";display:block;height:.07143rem;left:0;position:absolute;width:100%}._3HTjm0YAo1mkGx33qaEd-V:after{display:none}.tBDFerrjes4WBHYRcS3_W{color:#b4b4b4;font-size:.95em;font-weight:400;margin:0}._1v6boB0HUscXFSmn2UTCnG{border-bottom:.07143rem solid transparent;font-size:1rem;margin:0;padding-bottom:.57143rem;white-space:pre-line}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"ReadOnlyField_board": "gA4cC0vw1fFCPR_7UtEb4",
	"ReadOnlyField_board___noDivider": "_3HTjm0YAo1mkGx33qaEd-V",
	"ReadOnlyField_h5": "tBDFerrjes4WBHYRcS3_W",
	"ReadOnlyField_p": "_1v6boB0HUscXFSmn2UTCnG"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/_omni-operation-ui_release_2.7.2/node_modules/omni-common-ui/postcss.config.js"}}!./containers/Group/ProgressReportHFv4/IndividualDevelopmentPlanDetailView/ReadOnlyField/style.postcss
// module id = 1994
// module chunks = 0